$(document).ready(() => {
  let defaultCountry = null
  const errorMap = [
    "Invalid number",
    "Invalid country code",
    "Too short",
    "Too long",
    "Invalid number",
  ];
  function setupTelInput(element, type) {
    return window.intlTelInput(element, {
      initialCountry: "auto",
      hiddenInput: `full-phone`,
      geoIpLookup: (callback) => {
        if (defaultCountry) {
          callback(defaultCountry);
        } else {
          fetch("https://ipapi.co/json")
            .then((res) => res.json())
            .then((data) => {
              defaultCountry = data.country_code;
              const hiddenCountryValue = document.getElementById("hiddenCountryValue"); 
              hiddenCountryValue.value = data.country_name;
              callback(data.country_code);
            })
            .catch(() => callback("be"));
        }
      },
      utilsScript:
        "https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js",
    });
  }

  const telSeat = document.querySelector("#form-seat #tel-seat");
  const telFree = document.querySelector("#form-free #tel-free");

  if (telFree) {
    const intlTelFree = setupTelInput(telFree, "free");
    intlTelFree.a.addEventListener("keyup", function (event) {
      const input = document.querySelector("#tel-free");

      if (input.value.trim()) {
        if (!intlTelFree.isValidNumber()) {
          const errorCode = intlTelFree.getValidationError();
          if (errorCode <= 0) {
            input.parentElement.parentElement.dataset.error = "true";
            input.parentElement.parentElement.dataset.errorMessage = "";
          } else {
            input.parentElement.parentElement.dataset.error = "true";
            input.parentElement.parentElement.dataset.errorMessage =
              errorMap[errorCode];
          }
        } else {
          input.parentElement.parentElement.removeAttribute("data-error");
          input.parentElement.parentElement.removeAttribute(
            "data-error-message"
          );
        }
      }

      if (intlTelFree.isValidNumber()) {
        intlTelFree.hiddenInput.value = `${intlTelFree.getNumber()}`;
      } else {
        intlTelFree.hiddenInput.value = null;
      }
    });
  }

  if (telSeat) {
    const intlTelSeat = setupTelInput(telSeat, 'seat');
    intlTelSeat.a.addEventListener("keyup", function (event) {
      const input = document.querySelector("#tel-seat");
      const errorMsg = document.querySelector("#error-msg-seat");
  
      if (input.value.trim()) {
        if (!intlTelSeat.isValidNumber()) {
          const errorCode = intlTelSeat.getValidationError();
          if (errorCode <= 0) {
            input.parentElement.parentElement.dataset.error = 'true'
            input.parentElement.parentElement.dataset.errorMessage = ''
          } else {
            input.parentElement.parentElement.dataset.error = "true";
            input.parentElement.parentElement.dataset.errorMessage = errorMap[errorCode];
          }
        } else {
          input.parentElement.parentElement.removeAttribute('data-error');
          input.parentElement.parentElement.removeAttribute('data-error-message');
        }
      }
  
      if (intlTelSeat.isValidNumber()) {
        intlTelSeat.hiddenInput.value = `${intlTelSeat.getNumber()}`;
      } else {
        intlTelSeat.hiddenInput.value = null;
      }
    });
  }
  

  
  
  // let telInputFree = intlTelFree.input;
  // telInputFree.addEventListener("keyup", function (event) {
  //   let number = intlTelFree.getNumber();
  //   document.querySelector("#bookingfree input[name='full-phone']").value = number;
  // });
  // let telInputSeat = intlTelSeat.input;
  // telInputSeat.addEventListener("keyup", function (event) {
  //   let number = intlTelSeat.getNumber();
  //   document.querySelector("#bookingseat input[name='full-phone']").value = number;
  // });

  

  fetch("https://restcountries.com/v3.1/all?fields=cca2,name,flags")
    .then((response) => response.json())
    .then((data) => {
      const sortedCountries = data.sort((a, b) =>
        a.name.common.localeCompare(b.name.common)
      );

      populateDropdown(sortedCountries);
      addSearchFunctionality();
      if (telFree) {
        addLabelListeners('free');
      }
      if (telSeat) {
        addLabelListeners("seat");
      }
    });

  function populateDropdown(countries) {
    const dropdown = document.getElementById("optionsCountry");
    const selectedCountryElem = document.getElementById("selectedCountry");
    const countryContent = document.getElementById("country-content");
    const countryFlag = document.getElementById("country-flag");
    const hiddenCountryValue = document.getElementById("hiddenCountryValue");  
    
    if (!dropdown) {
      return
    }

    countries.forEach((country) => {
      const optionDiv = document.createElement("div");
      optionDiv.className = `dropdown-option flag-icon flag-icon-${country.cca2.toLowerCase()}`;
      optionDiv.dataset.value = country.cca2;

      const countryImg = document.createElement("img");
      countryImg.src = country.flags.svg;

      const countryNameSpan = document.createElement("span");
      countryNameSpan.textContent = country.name.common;

      optionDiv.appendChild(countryImg);
      optionDiv.appendChild(countryNameSpan);

      if (defaultCountry && defaultCountry == country.cca2) {
        countryContent.textContent = country.name.common;
        countryFlag.className = countryFlag.className
          .split(" ")
          .filter((className) => !className.startsWith("iti__"))
          .join(" ");
        countryFlag.classList.add(
          "iti__flag",
          `iti__${country.cca2.toLowerCase()}`
        );
      }

      optionDiv.addEventListener("click", function () {
        countryContent.textContent = country.name.common;
        countryFlag.className = countryFlag.className
          .split(" ")
          .filter((className) => !className.startsWith("iti__"))
          .join(" ");
        countryFlag.classList.add('iti__flag', `iti__${country.cca2.toLowerCase()}`);

        toggleDropdown(false);

        const allOptions = document.querySelectorAll(".dropdown-option");
        allOptions.forEach((opt) => opt.classList.remove("selected"));

        optionDiv.classList.add("selected");
        hiddenCountryValue.value = country.name.common;
      });

      dropdown.appendChild(optionDiv);
    });

    if (selectedCountryElem) {
      selectedCountryElem.addEventListener("click", () => toggleDropdown());
    }

  }

  function toggleDropdown(close = false) {
    const dropdown = document.getElementById("optionsCountry");
    const selectedCountry = document.getElementById("selectedCountry");

    if (close || dropdown.classList.contains("show")) {
      if (dropdown) {
        dropdown.classList.remove("show");
      }
      if (selectedCountry) {
        selectedCountry.classList.remove("opened");
      }
    } else {
      if (dropdown) {
        dropdown.classList.add("show");
      }
      if (selectedCountry) {
        selectedCountry.classList.add("opened");
      }
    }
  }

  function addSearchFunctionality() {
    const searchInput = document.getElementById("searchCountryInput");

    if (!searchInput) {
      return
    }

    searchInput.addEventListener("keyup", function () {
      const query = this.value.toLowerCase();
      const allOptions = document.querySelectorAll(".dropdown-option");

      allOptions.forEach((option) => {
        const countryName = option.textContent.toLowerCase();
        option.style.display = countryName.includes(query) ? "block" : "none";
      });
    });
  }

  function addLabelListeners(form) {
    const labelsFree = document.querySelectorAll(
      `#form-${form} form label:not([for=gdpr]) input`
    );
    labelsFree.forEach((label) => {
      label.addEventListener("focus", () => toggleDropdown(true));
    });
  }


  $("#booking-free, #booking-free-top").click(function (e) {
    e.preventDefault();
    if ($("#form-free").hasClass("submitted")) {
      $("#form-free").toggleClass("open");
      $("#bookingfree").get(0).reset();
      $("#form-free .form-container form").removeClass("submitting");
      $("#form-free .form-container form label").removeClass("filled");
      $("#form-free").removeClass("submitted");
      $("#form-free h2 .blind-text").text("Book a free consultation");
      $("#form-free .form-container").css("display", "");
    }
    $("#form-free").toggleClass("open");
    $("#form-free").toggleClass("waypoint");
  });
  
  $("#booking-seat, #booking-seat-top").click(function (e) {
    e.preventDefault();
    if ($("#form-seat").hasClass("submitted")) {
      resetFormSeat();
    }
    $("#form-seat").toggleClass("waypoint");

    if (!$("#form-seat").hasClass("open")) {
      let height = 40 + $("#form-seat .container").outerHeight(true);
      $("#form-seat").css("height", `${height}px`);
      $("#form-seat").addClass("open");
    } else {
      $("#form-seat").css("height", 0);
      setTimeout(() => {
        $("#form-seat").removeClass("open");
        $("#bookingseat").addClass("hidden");
      }, 600);
    }
  });

  function resetFormSeat() {
    $("#form-seat").removeClass("open");
    $("#bookingseat").get(0).reset();
    $("#form-seat .form-container form").removeClass("submitting");
    $("#form-seat .form-container form label").removeClass("filled");
    $("#form-seat").removeClass("submitted");
    $("#form-seat h2 .blind-text").text("Book your seat");
    $("#form-seat .form-container").css("display", "");
  }

  $("#training-bi-dates li:not(.date-full)").click(function (e) {
    e.preventDefault();

    $("#training-bi-dates li:not(.date-full)").each(function (index, el) {
      $(el).removeClass("selected");
    });

    $(this).addClass("selected");

    let date = $(this).find("span").first().text();
    date = date == 'Subscribe' ? '' : date

    $("#form-seat input[name='training-date']").val(date);
    $("#bookingseat").removeClass("hidden");
    if (!$("#bookingseat").hasClass("hidden")) {
      let height = 40 + $("#form-seat .container").outerHeight(true);
      $("#form-seat").css("height", `${height}px`);
    } else {
      $("#form-seat").css("height", 0);
    }
  });


  

});
